module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form class=\"daterange-picker\"> <div class=\"form-group form-group-sm has-feedback-left\"> <span class=\"glyphicon glyphicon-calendar form-control-feedback\"></span> <input type=\"text\" class=\"form-control\" id=\"start_datepicker\" value=\"")
    ; __append(escapeFn( locals.start_date ))
    ; __append("\"> </div> <div class=\"separator\">to</div> <div class=\"form-group form-group-sm has-feedback-left\"> <span class=\"glyphicon glyphicon-calendar form-control-feedback\"></span> <input type=\"text\" class=\"form-control\" id=\"end_datepicker\" value=\"")
    ; __append(escapeFn( locals.end_date ))
    ; __append("\"> </div> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/datepickers_for_range.ejs
// module id = 848
// module chunks = 1